import axios from 'axios'
import * as FileSaver from 'file-saver'
import { REACT_APP_API } from '../../config'
import { XML_TYPE, b64toBlob } from 'Utilities'

export function validateCampaignWhatsAppRecipients(file, downloadErrorReport = false) {
    const formData = new FormData()
    formData.append('file', file)

    return axios
        .post(
            `${REACT_APP_API}/leads/campaign/validateWhatsAppRecipients?downloadErrorReport=${downloadErrorReport}`,
            formData,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
                timeout: 120000,
            },
        )
        .then((response) => response.data)
        .catch((error) => {
            console.error('Error al validar destinatarios de campaña', error)

            const errorData = error.response?.data

            if (errorData?.excelReport && downloadErrorReport) {
                const blob = b64toBlob(errorData.excelReport, XML_TYPE)
                if (blob) {
                    FileSaver.saveAs(blob, errorData.fileName || file.name)
                }
            }

            throw errorData || error
        })
}
